(() => {
  const btn = document.getElementById("backToTopBtn");
  if (!btn) return;

  const toggleVisibility = () => {
    btn.classList.toggle("opacity-0", window.scrollY <= 300);
  };

  window.addEventListener("scroll", toggleVisibility, { passive: true });
  toggleVisibility();

  btn.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
})();
